import React, {useContext, useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import SiteApi from '../../../../interface/api/site';
import {ManagementMenuOptionItem} from "../../../../component/menu-item";
import {makeItem} from '../../../../component/visit-application/visitor-status'
import {Pagination} from "../../../../component/paging";
import {Page} from "../../../../interface/model/page";
import {Search1} from "../../../../component/search";
import {HostStateContext} from "../../index";
import {convertDate} from "../../../../util/convertDate";

import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: '1px solid #e1e1e1',
        },
    },
});

function getDefaultSiteInfoSeq() {
    try {
        const hostInfo = JSON.parse(localStorage.getItem('hostInfo') || 'null');
        return hostInfo?.siteInfo?.seq || '';
    } catch (e) {
        return '';
    }
}


export default function VisitorInout() {
    const { auth, hostInfo } = useContext(HostStateContext);
    const classes = useRowStyles();
    const [visitorList, setVisitorList] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ siteInfoOptions, setSiteInfoOptions ] = useState<Array<any>>([]);
    const today = convertDate(new Date());
    const [ searchInfo , setSearchInfo ] = useState({
        searchToDate : today,
        searchFromDate : today,
        visitorInfoSearchType : 'visitorName',
        searchValue : '',
        siteInfoSeq : getDefaultSiteInfoSeq()
    })

    function changeStatusHandler(visitorInfo, visitorStatus) {
        if(visitorStatus === 'QR_RE_SEND') {
            Api.visitorQrCodeReSend(visitorInfo.seq).then(()=>{
                alert('QR코드 재발급 완료 되었습니다.');
            });
        } else {
            Api.visitorInfoChangeStatus(visitorInfo.seq, visitorStatus).then(res => {
                alert('정상적으로 처리되었습니다.');
                let resultVisitorInfo = res.data;
                setVisitorList({
                    ...visitorList, content : visitorList.content.map(
                        visitor =>
                            visitor.seq === resultVisitorInfo.seq
                                ? {...visitor, visitorStatus : resultVisitorInfo.visitorStatus}
                                : {...visitor}
                    )
                })
            })
        }
    }

    function excelDownload() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        let searchToDate = searchInfo.searchToDate;
        let searchFromDate = searchInfo.searchFromDate;
        let searchValue = searchInfo.searchValue;
        let visitorInfoSearchType = searchInfo.visitorInfoSearchType;
        let siteInfoSeq = searchInfo.siteInfoSeq;
        window.location.href=`/v1/visit-info/in-out/excel/download?hostInfoSeq=${hostInfo.number}&searchToDate=${searchToDate}&searchFromDate=${searchFromDate}&searchValue=${searchValue}&visitorInfoSearchType=${visitorInfoSearchType}&siteInfoSeq=${siteInfoSeq}`;
    }

    function searchHandler() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInOutInfoListBySearchPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    function pageMoveHandler(pageNumber) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInOutInfoListBySearchPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    function collectSiteInfosByDepth(siteInfo, targetDepth, result = []) {
        if (!siteInfo) {
            return result;
        }

        if (siteInfo.depth === targetDepth) {
            result.push(siteInfo);
        }
        if (siteInfo.childrenSiteInfos && siteInfo.childrenSiteInfos.length > 0 && siteInfo.depth < targetDepth) {
            siteInfo.childrenSiteInfos.forEach((childSiteInfo) => collectSiteInfosByDepth(childSiteInfo, targetDepth, result));
        }
        return result;
    }

    function getRootSiteInfo(siteInfo) {
        if (!siteInfo || !siteInfo.parentSiteInfo) {
            return siteInfo;
        }

        return getRootSiteInfo(siteInfo.parentSiteInfo);
    }

    useEffect(() => {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInOutInfoListBySearchPage(hostInfo.number, {
            searchToDate: today,
            searchFromDate: today,
            visitorInfoSearchType: 'visitorName',
            searchValue: '',
            siteInfoSeq: ''
        }, 0).then(res => setVisitorList(res.data));
        if (auth?.access?.urls && (auth.access.urls.length === 1 || auth.access.urls.length === 6) && hostInfo?.siteInfo?.seq) {
            const rootSiteInfo = getRootSiteInfo(hostInfo.siteInfo);
            SiteApi.siteInfoListBySeq(rootSiteInfo.seq).then(res => {
                setSiteInfoOptions(collectSiteInfosByDepth(res.data, 1));
            });
            return;
        }

        SiteApi.siteInfoList().then(res => {
            const siteInfos = [];
            res.data.forEach((siteInfo) => collectSiteInfosByDepth(siteInfo, 1, siteInfos));
            setSiteInfoOptions(siteInfos);
        });
    }, [auth, hostInfo, today])

    const showSiteInfoOptions = !!auth?.access?.urls && auth.access.urls.length !== 3;

    return (
        <>
            <div className="add">
                <div className="btn_left">
                    <p className="m_tit nv_bold pc_skip tpc_skip m_skip" onClick={excelDownload}>엑셀 다운로드</p>
                    <button type="button" className="nv_green_button down_icon_btn m_skip" onClick={excelDownload}>엑셀 다운로드</button>
                </div>
                <Search1
                    searchHandler={searchHandler}
                    searchInfo={searchInfo}
                    setSearchInfo={setSearchInfo}
                    siteInfoOptions={siteInfoOptions}
                    showSiteInfoOptions={showSiteInfoOptions}
                />
                <div className="nv_table_box adminVersion">
                    <TableContainer component={Paper}>
                        <table className={"nv_table"} aria-label="a dense table">
                            <thead>
                                <tr>
                                    <th align="center">방문자</th>
                                    <th align="center" className="tpc_skip m_skip">업체명</th>
                                    <th align="center" className="tpc_skip m_skip">연락처</th>
                                    <th align="center" className="tpc_skip m_skip">방문목적</th>
                                    <th align="center" className="tpc_skip m_skip">방문위치</th>
                                    <th align="center">방문기간</th>
                                    <th align="center">접견인</th>
                                    <th align="center" className="tpc_skip m_skip">방문시간</th>
                                    <th align="center" className="tpc_skip m_skip">차량번호</th>
                                    <th align="center" className="tpc_skip m_skip">상태</th>
                                    <th align="center">관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    visitorList!==undefined && visitorList.content.length > 0 ?
                                        visitorList.content.map((visitor, index) => (
                                        <>
                                            <tr className={classes.root}>
                                                <td align="center">
                                                    {
                                                        visitor.vipFlag !== null && visitor.vipFlag === true
                                                            ? '[VIP] ' + visitor.name
                                                            : visitor.name
                                                    }
                                                </td>
                                                <td align="center" className="tpc_skip m_skip">{visitor.company}</td>
                                                <td align="center" className="tpc_skip m_skip">{visitor.phone}</td>
                                                <td align="center" className="tpc_skip m_skip">{`${visitor.visitorApplicationInfo.visitPurpose} (${visitor.visitorApplicationInfo.visitPurposeDetail})`}</td>
                                                <td align="center" className="tpc_skip m_skip">{visitor.visitorApplicationInfo.visitLocation}</td>
                                                <td align="center">{`${visitor.visitorApplicationInfo.startDate}~${visitor.visitorApplicationInfo.endDate}`}</td>
                                                <td align="center">{visitor.visitorApplicationInfo.hostInfo.name}</td>
                                                <td align="center" className="tpc_skip m_skip">
                                                    {
                                                        `${visitor.visitorApplicationInfo.startTime}~${visitor.visitorApplicationInfo.endTime}`
                                                    }
                                                </td>
                                                <td align="center" className="tpc_skip m_skip">{visitor.car}</td>
                                                <td align="center" className="tpc_skip m_skip">{visitor.visitorStatus}</td>
                                                <td align="center">
                                                    <ManagementMenuOptionItem items={makeItem(changeStatusHandler, visitor)}/>
                                                </td>
                                            </tr>
                                        </>
                                    )) : <tr>
                                            <td colSpan={11} align="center">등록된 방문 입출문 정보가 없습니다.</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </TableContainer>
                    <Pagination page={visitorList} pageMoveHandler={pageMoveHandler} />
                </div>
            </div>
        </>
    )
}
